import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SpinnerService } from '../../../../services/spinner.service';
import {
  CampanacontrollerService,
  CampanaAdheridosControllerService,
  CampanaErroresFilterDTO,
  CampanaGestoresResiduosControllerService,
  CampanaPoseedoresControllerService
} from 'api-rest';
import { DownloadService } from '../../../../services/download.service';
@Component({
  selector: 'lib-declaration-campaign-errors',
  templateUrl: './declaration-campaign-errors.component.html',
  styleUrls: ['./declaration-campaign-errors.component.scss']
})
export class DeclarationCampaignErrorsComponent {
  pageNumber: number = 0;
  pageSize: number = 25;
  recordsTotal: number = 0;
  headArray: any = [
    {
      Head: 'ID Adherido',
      FieldName: 'adherido',
      Attribute: 'id',
    },
    {
      Head: 'Error',
      FieldName: 'error',
      Tooltip: true,
    },
    {
      Head: 'Corregido',
      FieldName: 'correcion',
      renderValue: (item: any) => item === true ? 'Sí' : 'No',
    }
  ];

  headArray2: any = [
    {
      Head: 'ID Gestor',
      FieldName: 'gestorResiduos',
      Attribute: 'id',
    },
    {
      Head: 'ID Poseedor',
      FieldName: 'poseedor',
      Attribute: 'id',
    },
    {
      Head: 'Error',
      FieldName: 'error',
      Tooltip: true,
    },
    {
      Head: 'Corregido',
      FieldName: 'correcion',
      renderValue: (item: any) => item === true ? 'Sí' : 'No',
    }
  ];
  campaniaId!: number;
  gridArray: any[] = [];
  itemsPerPageOptions: number[] = [25, 50, 75, 100];
  selectedItemsPerPage: number = 25;
  flagSearch: boolean = false;
  totalElements: number = 0;
  totalSearch: number = 0;
  
  tipo: string = 'DAE';
  currentHeadArray: any[] = [];

  constructor(
    @Inject('environment') private environment: any,
    public dialogRef: MatDialogRef<DeclarationCampaignErrorsComponent>,
    public spinnerSrv: SpinnerService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public CamapanaAdheridosService: CampanaAdheridosControllerService,
    private downloadSrv: DownloadService,
    public CamapanaGestoresService: CampanaGestoresResiduosControllerService,
    private campanaPoseedoresControllerService : CampanaPoseedoresControllerService
  ) {
      this.campaniaId = this.data.campaniaId;
      this.tipo = this.data.tipo || 'DAE';
    }

  ngOnInit(): void {
    if (this.tipo === 'CVFGestor' || this.tipo === 'CVFPoseedor') {
      this.currentHeadArray = this.headArray2;
    } else {
      this.currentHeadArray = this.headArray;
    }
    this.obtenerErroresCampania();
  }

  obtenerErroresCampania(){
    const { backendFilter, page, size } = this.getBackendFilter();
    
    if (this.tipo === 'CVFGestor' || this.tipo === 'CVFPoseedor') {
      this.CamapanaGestoresService.findAll10(backendFilter, {page: page, size: size, sort:['desc']})
        .subscribe({
          next: (data: any) => {
            if (data) {
              this.flagSearch = data.datos?.length !== 0 ? true : false;
              this.gridArray = data.datos ?? [];
              this.recordsTotal = data.paginacion?.totalElements ?? 0;
              this.totalSearch = this.gridArray.length;
            }
            this.spinnerSrv.loadingHide();
          },
          error: () => {
            this.spinnerSrv.loadingHide();
          },
        });
    } else {
      this.CamapanaAdheridosService.findAll8(backendFilter, {page: page, size: size, sort:['desc']})
        .subscribe({
          next: (data: any) => {
            if (data) {
              this.flagSearch = data.datos?.length !== 0 ? true : false;
              this.gridArray = data.datos ?? [];
              this.recordsTotal = data.paginacion?.totalElements ?? 0;
              this.totalSearch = this.gridArray.length;
            }
            this.spinnerSrv.loadingHide();
          },
          error: () => {
            this.spinnerSrv.loadingHide();
          },
        });
    }
  }


  private getBackendFilter() {

      let backendFilter: CampanaErroresFilterDTO = {
        campana: {
          id: this.campaniaId
        },
        correcion: false,
      };
      const page = this.pageNumber <= 1 ? 0 : this.pageNumber - 1;
      return { backendFilter, page, size: this.pageSize };
    }

  cerrar(): void {
    this.dialogRef.close(null);
  }

  renderPage(event: number) {
    this.pageNumber = event;
    this.obtenerErroresCampania();
  }

  exportar(): void {
 const { backendFilter, page, size } = this.getBackendFilter();
    // let filtro : CampanaErroresFilterDTO = this.data;
    this.spinnerSrv.loadingShow();
    if(this.tipo === 'CVFGestor' || this.tipo === 'CVFPoseedor'){
          this.campanaPoseedoresControllerService.exportCampanaErroresPoseedores(backendFilter!, 'response')
      .subscribe((res) => {
        this.spinnerSrv.loadingHide();
        const fileName = this.downloadSrv.getFileName(res.headers, 'envases.xlsx');
        this.downloadSrv.downloadBlob(res.body!, fileName!);
      });
    }
    else if (this.tipo === 'DAE'){
      this.CamapanaAdheridosService.exportCampanaErrores(backendFilter!, 'response')
      .subscribe((res) => {
        this.spinnerSrv.loadingHide();
        const fileName = this.downloadSrv.getFileName(res.headers, 'envases.xlsx');
        this.downloadSrv.downloadBlob(res.body!, fileName!);
      });
    }
  }

}
